export const MAX_BUCKET_COUNT = 5;
